import React from 'react';

import Axios from 'axios';

import styled from 'styled-components';

import { openDocument } from '@libs/NwPrivateFile';
import { getFileTypeIcons } from '@libs/NwUtils';

import { onUploadLegal } from '@hooks/API/Contact/UseContactLegals';
import { useAdjustTagUsageCount } from '@hooks/CachedLists/UseTagCatalog';

import NwDropDownMenu from '@components/Gui/NwDropDownMenu';
import NwIcon from '@components/Gui/NwIcon';
import NwUpload from '@components/Gui/NwUpload';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const LegalUploadContainer = styled.div`
    .upload-list {
        .upload-list-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
    }
    .upload-button-container {
        text-align: left;
        margin: 1rem 0 0 0;
    }
`;

const LegalUpload = ({ item }) => {
    const adjustTagUsageCount = useAdjustTagUsageCount();

    const deleteDocument = (documentToDelete) => {
        Axios.delete(`/documents/?ids=${documentToDelete.ID}`)
            .then(() => {
                // il documento eliminato non usa piu' i suoi tag
                (documentToDelete.Tags || []).forEach((tag) => adjustTagUsageCount(tag.ID, -1));
                onUploadLegal(item.ContactID);
            })
            .catch((error) => {
                console.error('Errore', error);
            });
    };

    const renderFile = (doc) => {
        return (
            <a
                href="#"
                onClick={(event) => {
                    event.preventDefault();
                    openDocument(doc);
                }}
            >
                <NwIcon icon={getFileTypeIcons(doc.Extension)} style={{ marginRight: 8 }} />
                <span>{doc.Title}</span>
            </a>
        );
    };

    const downloadDocument = (document) => {
        openDocument(document, { download: true });
    };

    const renderDocumentActions = (document) => {
        return [
            <div className="actions-container">
                <NwDropDownMenu
                    size="small"
                    actions={[
                        {
                            name: '',
                            key: 'preview',
                            pinned: true,
                            icon: byPrefixAndName.fasl['cloud-download'],
                            action: () => downloadDocument(document),
                        },
                        {
                            name: '',
                            key: 'delete',
                            pinned: true,
                            icon: byPrefixAndName.fasl['trash-alt'],
                            action: () => deleteDocument(document),
                            type: 'delete',
                            confirmationPlacement: 'left',
                        },
                    ]}
                />
            </div>,
        ];
    };

    return (
        <LegalUploadContainer>
            <div className="upload-list">
                {item.Documents.length > 0 &&
                    item.Documents.map((documentUpload) => (
                        <div className="upload-list-item" key={documentUpload.ID}>
                            {renderFile(documentUpload)}
                            {renderDocumentActions(documentUpload)}
                        </div>
                    ))}
            </div>
            <div className="upload-button-container">
                <NwUpload
                    maxSize={20}
                    showList={false}
                    types={[
                        'document',
                        'image',
                        'data-document',
                        'office-document',
                        'archive-document',
                        'text-document',
                    ]}
                    onUploadStart={() => {}}
                    onUploadEnd={() => {
                        onUploadLegal(item.ContactID);
                    }}
                    endpoint={`documents/uploadsingle/1?contactID=${item.ContactID}&legalID=${item.ID}`}
                />
            </div>
        </LegalUploadContainer>
    );
};

export default LegalUpload;
